import { diffDays } from '@/utils/time.util';

export const isNewNotice = (createDate: number): boolean => {
  return diffDays(createDate) <= 7;
};
